import get from 'lodash/get'
import { default as deserialize, formatMeta } from 'app/utils/deserialize'
import { fetch, update } from 'app/utils/data'
import { buildFilters } from './utils'

export default {
  namespaced: true,

  state: {
    list: [],
    item: {
      subscription: {},
      total: {}
    },
    pagination: {}
  },

  getters: {
    currentStripeSubscriptions: (state) => state.list,
    currentStripeSubscription: (state) => state.item,
    currentPagination: (state) => state.pagination
  },

  mutations: {
    stripeSubscriptionsFetched(state, { stripeSubscriptions }) {
      state.list = stripeSubscriptions
    },

    stripeSubscriptionFetched(state, { stripeSubscription }) {
      state.item = stripeSubscription
    },

    paginationFetched(state, { pagination }) {
      state.pagination = pagination
    }
  },

  actions: {
    async fetchStripeSubscriptions({ commit }, { page = 1, filters = {} }) {
      const response = await fetch({
        url: '/api/admin/stripe-subscriptions',
        params: {
          page,
          ...buildFilters(filters)
        }
      })

      const stripeSubscriptions = await deserialize(response.data)
      const pagination = formatMeta(get(response.data, 'meta', {}))

      commit('stripeSubscriptionsFetched', { stripeSubscriptions })
      commit('paginationFetched', { pagination })
    },

    async fetchStripeSubscription({ commit }, stripeSubscriptionId) {
      const response = await fetch({ url: `/api/admin/stripe-subscriptions/${stripeSubscriptionId}` })
      const stripeSubscription = await deserialize(response.data)

      commit('stripeSubscriptionFetched', { stripeSubscription })
    },

    async updateStripeSubscription({ commit, state, dispatch }, changes) {
      const response = await update({
        url: `/api/admin/stripe-subscriptions/${state.item.id}`,
        patch: true,
        type: 'stripeSubscription',
        changes,
        record: state.item
      })

      const stripeSubscription = await deserialize(response.data)

      commit('stripeSubscriptionFetched', { stripeSubscription })
    }
  }
}
